import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export function BlurOverlay({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('h-full w-full backdrop-blur-sm backdrop-grayscale-[0.2]', className)} {...props} />
}
